export enum LightUserDataRaymarching {
	PENUMBRA = 'raymarchingPenumbra',
	SHADOW_BIAS_ANGLE = 'raymarchingShadowBiasAngle',
	SHADOW_BIAS_DISTANCE = 'raymarchingShadowBiasDistance',
}
